import { useState } from "react";
import { handleEntriesByGenders } from "../../../api/entries";
import { useQuery } from "@tanstack/react-query";
import AllEntries from "./AllEntries";

export default function Genders({ filters }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>({});
  const [title, setTitle] = useState<any>("Gender");
  const params = `startDate=${filters?.startDate}&endDate=${filters?.endDate}&branch=${filters?.branch}`;
  const { data: genders } = useQuery({
    queryKey: ["topGenders", filters],
    queryFn: () => handleEntriesByGenders({ params }),
  });

  return (
    <div className="col-span-2">
      <div className="flex flex-col">
        {genders?.map((item: any, index: number) => (
          <button
            key={index}
            onClick={() => {
              setTitle(item?.gender);
              setSelected(item?.gender);
              setVisible(true);
            }}
            className=" border border-gray-300 shadow-sm bg-purple-50"
          >
            <div className="flex justify-between p-1">
              <div className="font-bold text-black capitalize">
                {item?.gender}
              </div>
              <div>
                <span className="font-bold">{item?.count}</span>{" "}
                <span className="text-gray-400">Entries</span>
              </div>
            </div>
          </button>
        ))}
      </div>

      {isVisible && (
        <AllEntries
          isVisible={isVisible}
          setVisible={setVisible}
          title={title}
          gender={selected}
          startDate={filters?.startDate}
          endDate={filters?.endDate}
        />
      )}
    </div>
  );
}
